@import '@alfalab/core-components-vars/src/index.css';
@import '../../../../calendar/src/vars.css';

:root {
    --calendar-popover-border-radius: var(--border-radius-8);
}

.component {
    display: inline-block;
    outline: none;
    position: relative;
}

.calendarContainer {
    display: inline-block;
    box-sizing: border-box;
    border-radius: var(--calendar-popover-border-radius);
    border: 1px solid var(--color-light-neutral-300);

    @media (max-width: 374px) {
        width: 100%;
        min-width: 288px;
    }
}

.calendarResponsive {
    width: var(--calendar-width);
}

.block {
    width: 100%;
}

.calendarIcon {
    margin-right: var(--gap-12-neg);
    height: 100%;
}
